/** @deprecated use {@link notNullish} instead */
export function notEmpty<TValue>(
  value: TValue | null | undefined,
): value is TValue {
  return notNullish(value);
}

/**
 * Utility for determining if a value is 'nullish' (`null` or `undefined`).
 *
 * Particularly useful with Array.filter since this will properly type-guard
 * the result
 */
export function notNullish<TValue>(
  value: TValue | null | undefined,
): value is TValue {
  if (value == null) return false;
  return true;
}

export function notError<TValue>(result: TValue | Error): result is TValue {
  return !(result instanceof Error);
}
